/* eslint-disable no-console */

const AppLogger = {
	init: () => {
		window.developerMode = import.meta.env.VITE_DEVELOPER_MODE === 'true';
	},
	log: (...args) => {
		window.developerMode && console.log(...args);
	},
	error: (...args) => {
		window.developerMode && console.error(...args);
	},
	warn: (...args) => {
		window.developerMode && console.warn(...args);
	},
	info: (...args) => {
		window.developerMode && console.info(...args);
	}
};

export default AppLogger;
